export async function translateText(text, targetLanguage) {
  const url = `https://api.mymemory.translated.net/get?de=oksana@atticum.no&q=${encodeURIComponent(
    text
  )}&langpair=uk|${targetLanguage}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.responseStatus === 200 && data.responseData) {
      return data.responseData.translatedText;
    } else {
      throw new Error("Failed to fetch translation");
    }
  } catch (error) {
    console.error("Error fetching translation:", error);
    return text;
  }
}
